import { FC, useEffect } from "react";
import { GrainLoader } from "@/components/ui/GrainLoader";
import { signOut } from "@firebase/auth";
import { useAuth } from "@/contexts/AuthContext";
import { auth } from "@/config/firebase";
import { useNavigate } from "react-router-dom";
import { resetShareInstallCache } from "@/hooks/useSlack";

export const LogoutComponent: FC = () => {
  const navigate = useNavigate();
  const { removeAuthTokenCookie, removeSarasGlobalCookie, removeUserDetails } = useAuth();
  useEffect(() => {
    removeAuthTokenCookie();
    removeSarasGlobalCookie();
    // Clear the user-details cookie (name, email, userId, companyId) so PII
    // does not linger on shared browsers after the user signs out.
    removeUserDetails?.();
    resetShareInstallCache();
    signOut(auth).then(() => {
      navigate("/auth");
    });
  }, []);
  return <GrainLoader />;
};
